export default "__VITE_ASSET__8aef155d__"